//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import appConst from '@/tools/appConst.js';

export default {
  name: 'SubscribeHero2026AiPartners',
  props: {
    embedded: {
      type: Boolean,
      default: false,
    },
    models: {
      type: Array,
      default: () => appConst.AI_PARTNERS,
    },
  },
  methods: {
    aiModelLogo(model) {
      return this.$cdnImg(`/img/subscribe/model-${model}.svg`);
    },
  },
};
